import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Products from "../views/Products.vue";
import Team from "../views/Team.vue";
import Approach from "../views/Approach.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    label: "Home",
    component: Home,
    icon: ['fas', 'home']
  },
  {
    path: "/team",
    name: "Team",
    label: "Our Team",
    icon: ['fas', 'user-friends'],

    component: Team
  },
  {
    path: "/products",
    name: "Products",
    label: "Products & Services",
    component: Products,
    icon: ['fas', 'briefcase']

  },
  {
    path: "/approach",
    name: "Approach",
    label: "Our Approach",
    icon: ['fas', 'handshake'],
    component: Approach
  },
  {
    path: "/resources",
    name: "Resources",
    label: "Resources",
    icon: ['fas', 'chart-line']
    //component: Products
  }
];

const router = new VueRouter({
  routes
});

export default router;
